<template>
  <div id="layerContainer">
    <button
      id="toggleLayerHudButton"
      class=""
      @click="toggleLayerHud"
      :class="{ active: LayerControlsOpen }"
      data-toggle="tooltip"
      data-placement="top"
      title="Map Layers"
    >
      <i class="fas fa-3x fa-layer-group"></i>
    </button>
    <div id="layerGrid" :class="{ layerControlsActive: LayerControlsOpen }">
      <button
        id="tnrv5"
        :class="{ active: activeBaseLayers.pathways }"
        @click="toggleLayer('pathways')"
      >
        SAFE BICYCLE STREETS
      </button>
      <button
        id="osmbikes"
        :class="{ active: activeBaseLayers.bikelanes }"
        @click="toggleLayer('bikelanes')"
      >
        BICYCLE LANES
      </button>
      <!-- <button
      id="lowstress"
      :class="{ active: activeBaseLayers.lowstress }"
      @click="toggleLayer('lowstress')"
    >
      LOW STRESS ROADS
    </button> -->
      <button
        id="hawks"
        :class="{ active: activeBaseLayers.hawks }"
        @click="toggleLayer('hawks')"
      >
        HAWK CROSSING
      </button>
      <button
        id="highstress"
        :class="{ active: activeBaseLayers.highstress }"
        @click="toggleLayer('highstress')"
      >
        HIGH STRESS ROADS
      </button>

      <button
        id="theloop"
        :class="{ active: activeBaseLayers.theloop }"
        @click="toggleLayer('theloop')"
      >
        THE LOOP PATH
      </button>
      <button
        id="satellite"
        :class="{ active: activeBaseLayers.satellite }"
        @click="toggleLayer('satellite')"
      >
        SATALLITE
      </button>
      <div></div>
      <button
        id="annotation"
        :class="{ active: activeBaseLayers.annotations }"
        @click="toggleLayer('annotations')"
      >
        STREET NAMES
      </button>
      <button
        id="streetlights"
        :class="{ active: activeBaseLayers.streetlights }"
        @click="toggleLayer('streetlights')"
      >
        STREET LIGHTS
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      LayerControlsOpen: false
    };
  },
  computed: {
    ...mapState(["activeBaseLayers"])
  },
  methods: {
    toggleLayerHud() {
      this.LayerControlsOpen = !this.LayerControlsOpen;
    },
    toggleLayer(layer) {
      this.$store.commit("toggleActiveBaseLayers", layer);

      // this.$emit("toggleMapBaseLayer", layer);
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 812px) {
  #layerContainer {
    button {
      width: 70px;
      height: 70px;
      font-size: 0.7em;
    }
  }
}

@media (min-width: 812px) {
  #layerContainer {
    button {
      width: 70px;
      height: 70px;
      font-size: 0.7em;
    }
  }
}

#layerContainer {
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 1px grey;
    outline: none;
    box-shadow: 2px 2px 6px #464646;

    font-stretch: 100%;
    letter-spacing: 2px;
    line-height: normal; /*margin: 4px;*/
    font-weight: 700;

    &.active {
      // border: solid 2px black;
      transform: scale(0.9);
      box-shadow: 1px 1px 2px rgb(10, 10, 10);
    }

    &:hover {
      font-weight: 900; // font-size: 2vmin;
      // transform: scale(1.1);
    }

    // width: 9vw;
    // height: 9vw;

    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
  }

  #toggleLayerHudButton {
    position: absolute;
    left: 20px;
    bottom: calc(12vh + 30px); //height of bottom hud + my preferred spacing
    z-index: 2;
    font-weight: 900;
    color: #5c5c5c;
    border: solid 1px black;
    border-radius: 50%;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
  }

  #layerGrid {
    > button {
      border: solid 1px black;
      font-size: 0.5em;
      border-radius: 5%;
    }

    &.layerControlsActive {
      // border: solid 2px rgb(119, 177, 119);
      width: auto;
      height: auto;
      overflow: visible;
      left: 20px;
      bottom: calc(12vh + 30px); //height of bottom hud + my preferred spacing
    }
    left: -500px;
    bottom: calc(10vh - 500px); //height of bottom hud + my preferred spacing

    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;

    // border: solid 2px red;
    // overflow: hidden;
    // width: calc(6vw);
    // height: calc(6vw);

    position: absolute;
    // right: 60px;
    // left: 20px;
    bottom: calc(12vh + 30px); //height of bottom hud + my preferred spacing
    // width: 38vw;
    margin: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 8px; /*or grid-column-gap and grid-row-gap for additional customation*/
    grid-template-rows: auto auto auto; /*this is implied but im stating it explicitly*/
  }

  #tnrv5 {
    background-image: url("../assets/legend/TucsonPathways.png");
    background-size: contain;
    color: #828282;
  }
  #highstress {
    background-image: url("../assets/legend/HighStress.png");
    background-size: contain;
    color: #a42323;
  }
  #lowstress {
    background-image: url("../assets/legend/LowStress.png");
    background-size: contain;
    color: #76a4e0;
  }
  #hawks {
    background-image: url("../assets/legend/HAWKS.png");
    background-size: contain;
    color: #d9ac7d;
  }
  #osmbikes {
    background-image: url("../assets/legend/BikeLanes.png");
    background-size: contain;
    color: #589447;
  }
  #theloop {
    background-image: url("../assets/legend/Loop.png");
    background-size: contain;
    color: #d9ac7d;
  }
  #satellite {
    background-image: url("../assets/legend/Satallite.png");
    background-size: contain;
    color: white;
  }
  #annotation {
    background-image: url("../assets/legend/Annotation2.png");
    background-size: contain;
    color: #828282;
  }
  #streetlights {
    background-image: url("../assets/legend/Streetlights.png");
    background-size: contain;
    color: #d6c679;
  }

  #toolbar {
    z-index: 3; /*display: inline-grid; justify-items: center;
justify-content: center;*/
    display: inline-grid;
    justify-content: center;
    align-content: center;
    justify-self: center;
    align-self: start;
    align-items: center;
    margin-bottom: 100px;
    position: relative;
    grid-template-columns:
      1fr 1fr
      1fr;
    grid-gap: 8px; /*or grid-column-gap and grid-row-gap for additional
customation*/
    grid-template-rows: auto auto auto auto; /*this is implied but im
stating it explicitly*/ /*width:68vw;*/ /*bottom:600px;*/ /*center the div*/
    /*left: 50%;*/ /*transform: translate(-50%, 0);*/ /*looks a little cleaner
without it padding:10px; border: solid 3px #A0A0A0; background-color:#e4e4e4; */
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
    -o-transition: all 0.4s;
    transition: all 0.4s;
  } /*Custom Map Layer Buttons*/
  #toolbar > button {
    justify-self: center;
    vertical-align: bottom;
    border: solid 1px rgba(71, 71, 71, 0.87);
    box-shadow: 2px 2px 4px grey;
    border-radius: 0px;
    cursor: pointer;
    bottom: 0px; /*aligns all the buttons to the bottom of the toolbar, so that when
you hover over them, they push up by the toolbar > button:hover margin*/
    font-size: 1.5vmin;
    font-stretch: 100%;
    letter-spacing: 2px;
    line-height: normal; /*margin: 4px;*/
    padding: 0px;
    text-transform: uppercase;
    width: 9vw;
    height: 9vw;
    font-weight: 500;
    border-radius: 0px;
    overflow: hidden;
    text-align: center;
  }
  #toolbar > button:hover {
    font-weight: 900;
    -webkit-transition: all 0.2s;
    -moz-transition: all 0.2s;
    -o-transition: all 0.2s;
    transition: all 0.2s;
  }
  .shaded {
    background-color: yellow;
  } /*and make them bigger when clicked*/
  #toolbar > button.active {
    transform: scale(0.9);
  }
  @media (max-width: 1080px) {
    /*when on a small screen, make the legend go full width of the screen*/
    #toolbar {
      /*min-width:70%;*/
    } /*also make the buttons bigger*/
    #toolbar > button {
      width: 22vw;
      height: 22vw;
      font-size: 2vmin;
    } /*and make the background image in
the buttons, zoom in a little more so you can see their details in these tiny
buttons*/
    #tnrv5,
    #highstress,
    #lowstress,
    #hawks,
    #osmbikes,
    #theloop,
    #satellite,
    #annotation,
    #streetlights {
      background-size: cover;
    }
  }
}
</style>
